/* Embertine: Brücke vom Prototyp-Warenkorb (localStorage ll_cart) zur Shopify-Kasse. HEX 17.10.2026.
   Der Prototyp führt den Warenkorb im Browser. Beim Klick auf „Checkout / Zur Kasse“ wird daraus ein
   Shopify-Warenkorb gebaut (/cart/clear.js, /cart/add.js) und auf /checkout weitergeleitet. */
(function () {
  var LANG = (window.__SHOP && window.__SHOP.lang) || 'en';
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  function warenkorb() {
    try { return (JSON.parse(localStorage.getItem('ll_cart') || '{}').items) || []; } catch (e) { return []; }
  }

  function passt(v, wunsch) {
    if (!wunsch) return false;
    var w = String(wunsch).toLowerCase();
    if ((v.sku || '').toLowerCase() === w) return true;
    if ((v.title || '').toLowerCase() === w) return true;
    return (v.options || []).some(function (o) { return String(o).toLowerCase() === w; }) ||
           (v.title || '').toLowerCase().indexOf(w) >= 0;
  }

  /* Moon Letter (LOTSE 18.10., Auftrag HEX): Prototyp-Zeile moon-letter-<größe>-<linie>-<laufzeit>. Monatlich = Variante
     ML-<LINIE>-<GRÖSSE> mit dem Abo-Plan der Shopify-Subscriptions-App (selling_plan). Vorausbezahlt gibt es in Shopify noch nicht. */
  function mlTeile(item) {
    var m = /^moon-letter-([a-z]+)-([a-z]+)-(\d+)$/.exec(item.h || '');
    return m ? { size: m[1], line: m[2], term: m[3] } : null;
  }
  function mlMonatlich(item) { var t = mlTeile(item); return !!t && t.term === '1'; }
  function mlZeile(item) {
    var t = mlTeile(item), sku = ('ML-' + t.line + '-' + t.size).toUpperCase();
    // Vorausbezahlt (3/6/12) gibt es in Shopify nicht: nie still als Monatsabo zur Kasse schicken (LOTSE 19.10.).
    if (t.term !== '1') return Promise.reject(new Error('The Moon Letter: prepaid'));
    return fetch(ROOT + '/products/the-moon-letter.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('The Moon Letter'); return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).find(function (x) { return (x.sku || '').toUpperCase() === sku; });
        var g = (p.selling_plan_groups || [])[0], plan = g && g.selling_plans && g.selling_plans[0];
        if (!v || !plan) throw new Error('The Moon Letter');
        var eig = {};
        var gift = item.meta && item.meta.gift;
        if (gift) {
          if (gift.date) eig[LANG === 'de' ? 'Geschenk: erstes Paket am' : 'Gift: first box on'] = String(gift.date);
          if (gift.mail) eig[LANG === 'de' ? 'Geschenk: E-Mail' : 'Gift: email'] = String(gift.mail);
          if (gift.msg) eig[LANG === 'de' ? 'Geschenk: Nachricht' : 'Gift: message'] = String(gift.msg);
        }
        return { id: v.id, quantity: 1, selling_plan: plan.id, properties: eig };
      });
  }

  function variante(item) {
    if (item.kind === 'moonletter') return mlZeile(item);
    return fetch(ROOT + '/products/' + encodeURIComponent(item.h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(item.h); return r.json(); })
      .then(function (p) {
        var vs = p.variants || [];
        var v = vs.find(function (x) { return passt(x, item.v); }) ||
                vs.find(function (x) { return x.available; }) || vs[0];
        if (!v) throw new Error(item.h);
        var eig = {};
        if (item.meta && typeof item.meta === 'object') Object.keys(item.meta).forEach(function (k) { eig[k] = String(item.meta[k]); });
        return { id: v.id, quantity: item.qty || 1, properties: eig };
      });
  }

  function zurKasse(ev) {
    var a = ev.target.closest && ev.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/\/checkout\/?$/.test(href.split('?')[0])) return;
    ev.preventDefault();
    var items = warenkorb().filter(function (i) { return i.h && (i.kind !== 'moonletter' || mlMonatlich(i)); });
    var ohne = warenkorb().length - items.length;
    if (!items.length) { location.href = ROOT + '/cart'; return; }
    a.setAttribute('aria-busy', 'true');
    a.style.opacity = '.6';
    Promise.all(items.map(variante))
      .then(function (zeilen) {
        return fetch('/cart/clear.js', { method: 'POST' }).then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: zeilen }) });
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'cart'); });
        if (ohne) alert(LANG === 'de' ? 'Vorausbezahlte Moon Letter (3, 6 oder 12 Monate) sind noch nicht bestellbar. Der monatliche Moon Letter liegt im Warenkorb.' : 'Prepaid Moon Letters (3, 6 or 12 months) cannot be ordered yet. The monthly Moon Letter is in your bag.');
        location.href = '/checkout';
      })
      .catch(function (e) {
        a.removeAttribute('aria-busy'); a.style.opacity = '';
        alert((LANG === 'de' ? 'Ein Artikel ist gerade nicht bestellbar: ' : 'One item is not available right now: ') + e.message);
      });
  }

  document.addEventListener('click', zurKasse, true);

  /* Hero-Video steckt seit 17.10.2026 ~17:20 im Prototyp selbst (src/templates/index.mjs, .h2-film). */
})();
